import type { NotificationReadPort, Notification, NotificationPreferences, PushToken } from '../core/types';

export interface NotificationReadService {
  getNotifications(userId: string, limit?: number): Promise<Notification[]>;
  getUnreadCount(userId: string): Promise<number>;
  getPreferences(userId: string): Promise<NotificationPreferences | null>;
  getPushTokens(userId: string): Promise<PushToken[]>;
}

export function createNotificationReadService(port: NotificationReadPort): NotificationReadService {
  return {
    getNotifications: (userId, limit) => port.getNotifications(userId, limit),
    getUnreadCount: (userId) => port.getUnreadCount(userId),
    getPreferences: (userId) => port.getPreferences(userId),
    getPushTokens: (userId) => port.getPushTokens(userId),
  };
}
